// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f7b4a905","732":"8b097f81","977":"30cd7354"}[chunkId] + ".chunk.js";
};